import { Component, Show } from "solid-js";

interface AutoPrioritizeButtonProps {
  onClick: () => void;
  disabled: boolean;
  loading: boolean;
  disabledReason: string;
}

export const AutoPrioritizeButton: Component<AutoPrioritizeButtonProps> = (
  props,
) => {
  const isDisabled = () => props.disabled || props.loading;

  return (
    <button
      type="button"
      class={
        "inline-flex items-center justify-center gap-2 font-medium rounded transition-colors focus-ring " +
        "bg-surface text-ink border border-line hover:bg-paper " +
        "px-3 py-1.5 text-sm " +
        (isDisabled() ? "opacity-50 cursor-not-allowed" : "")
      }
      disabled={isDisabled()}
      aria-disabled={isDisabled()}
      title={props.disabled ? props.disabledReason : undefined}
      onClick={() => !isDisabled() && props.onClick()}
    >
      <span class="font-mono text-[9px] uppercase tracking-[0.12em] px-1 rounded-sm border border-signal-magenta/25 text-signal-magenta">
        ai
      </span>{" "}
      <Show
        when={!props.loading}
        fallback={
          <>
            <svg
              class="w-4 h-4 animate-spin"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <circle
                class="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                stroke-width="4"
              />
              <path
                class="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
              />
            </svg>
            <span>Analyzing…</span>
          </>
        }
      >
        <span>Auto-prioritize</span>
      </Show>
    </button>
  );
};
